export type AggregatedSecuringType = common.SecuringType | 'MIXED' | undefined

export const aggregateSecuringType = (
  securingTypes: common.SecuringType[],
): AggregatedSecuringType => {
  const unionSecuringTypes = [...new Set(securingTypes)]

  if (unionSecuringTypes.length === 0) {
    return undefined
  }

  if (unionSecuringTypes.length > 1) {
    return 'MIXED'
  }

  const isAllPrimary = unionSecuringTypes.every((securingType) => securingType.includes('PRIMARY'))
  if (isAllPrimary) return 'PRIMARY'

  const isAllSecondary = unionSecuringTypes.every((securingType) =>
    securingType.includes('SECONDARY'),
  )
  if (isAllSecondary) return 'SECONDARY'

  return 'MIXED'
}

export function containsSecondaryType(aggregatedType: AggregatedSecuringType | undefined): boolean {
  return aggregatedType === 'SECONDARY' || aggregatedType === 'MIXED'
}
